import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Navbar from "./Common/Navbar";
import Footer from "./Common/Footer";
import Background from "./components/ui/Background";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Skills from "./components/About/Skills";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/ResumeNew";
import Contact from "./components/Contactme/Contactme";
import "./style.css";

function App() {
  const [load, setLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoad(false), 900);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader load={load} />
      <Background />
      <Navbar />
      <main>
        <Home />
        <About />
        <Skills />
        <Projects />
        <Resume />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
